module.exports = __webpack_public_path__ + "img/BARCODE.c44dfd66.svg";